import { render, staticRenderFns } from "./matrixDetail.vue?vue&type=template&id=03f4b22a"
import script from "./matrixDetail.vue?vue&type=script&lang=js"
export * from "./matrixDetail.vue?vue&type=script&lang=js"
import style0 from "./matrixDetail.vue?vue&type=style&index=0&id=03f4b22a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f4b22a')) {
      api.createRecord('03f4b22a', component.options)
    } else {
      api.reload('03f4b22a', component.options)
    }
    module.hot.accept("./matrixDetail.vue?vue&type=template&id=03f4b22a", function () {
      api.rerender('03f4b22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/matrixDetail.vue"
export default component.exports